import React from "react";

import { Product, ProductKey, ProductSpecKey } from "../../../../commons/specs/product";
import { Currency } from "../../../../commons/types/currency";
import { AssortmentPriceSettings, CustomizationSettings } from "../../../../commons/types/settings";
import ProductTitle from "../../components/ProductTitle/ProductTitle";
import useSpecFormatter from "../../libs/hooks/use-spec-formatter";

import { OriginalPricePartial, PricePartial, SaleBadgePartial } from "./PricePartials";

type ProductTitleProps = React.ComponentProps<typeof ProductTitle>;

interface Props extends Pick<ProductTitleProps, "align" | "wrap" | "layout"> {
  product?: Product;
  name?: string;
  customization: CustomizationSettings;
  assortmentPriceSettings: AssortmentPriceSettings;
  currency: Currency;
}

const ProductTitlePartial = ({
  product = undefined,
  name: customName,
  align,
  wrap,
  customization,
  currency,
  assortmentPriceSettings
}: Props) => {
  const specFormatter = useSpecFormatter("commons", product?.[ProductKey.ProductType], customization);

  if (!specFormatter || !product) {
    return null;
  }

  const name = customName ?? specFormatter.formatProductValue(ProductSpecKey.ModelName, product) ?? "";
  const year = specFormatter.formatProductValue(ProductSpecKey.ModelYear, product);

  const pricePartialProps = {
    productOrVariant: product,
    customization,
    currency,
    assortmentPriceSettings,
    specFormatter
  };

  return (
    <ProductTitle
      align={align}
      wrap={wrap}
      name={name}
      year={year}
      showPrices={customization.showPrices}
      price={<PricePartial {...pricePartialProps} />}
      originalPrice={<OriginalPricePartial {...pricePartialProps} />}
      badge={<SaleBadgePartial {...pricePartialProps} />}
    />
  );
};

export default ProductTitlePartial;
